export default "__VITE_ASSET__763b9c2f__"